import { useMainContext } from '@/services/context';
import { Feature, searchCollegi, search_word } from '@/services/mapbox';
import * as React from 'react';
import { MainComponent } from './MainComponent';

export const Main = () => {
  const [options, setOptions] = React.useState<Feature[]>([]);
  const [inputValue, setInputValue] = React.useState('');
  const [inputError, setInputError] = React.useState(false);
  const { setVotingFeatures, addressFeature, setAddressFeature } =
    useMainContext();

  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    // don't search if input is less than 3 characters
    // or it's still loading/searching
    if (!inputValue || inputValue.length < 3) {
      return;
    }

    // clear last timeOut
    timeoutRef.current && clearTimeout(timeoutRef.current);

    // search after 3 seconds of last type
    timeoutRef.current = setTimeout(async () => {
      const data = await search_word(inputValue);

      setOptions(data);
    }, 1000);

    // clear when unmounting
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, [inputError, inputValue]);

  React.useEffect(() => {
    if (!addressFeature?.geometry) {
      return;
    }

    const placeType = addressFeature?.place_type
      ? addressFeature?.place_type[0]
      : '';
    const localCommunityIt = addressFeature.text_it;

    const showMultipleCollegiError =
      placeType === 'place' &&
      (addressFeature?.context || []).length > 0 &&
      ('Torino' === localCommunityIt ||
        'Milano' === localCommunityIt ||
        'Roma' === localCommunityIt ||
        'Napoli' === localCommunityIt ||
        'Palermo' === localCommunityIt ||
        'Genova' === localCommunityIt);

    if (showMultipleCollegiError) {
      setInputError(true);

      return;
    }

    const { coordinates } = addressFeature?.geometry;

    (async () => {
      const votingFeatures = await searchCollegi(
        coordinates[1],
        coordinates[0]
      );

      setVotingFeatures(votingFeatures);
    })();
  }, [setVotingFeatures, addressFeature]);

  const onInputValueChange = (v: string) => {
    // clear error state
    if (inputError) {
      setInputError(false);
    }

    if (options.length > 0) {
      setOptions([]);
    }

    setInputValue(v);
  };

  return (
    <MainComponent
      options={options}
      onOptionsChange={setOptions}
      value={addressFeature}
      onValueChange={setAddressFeature}
      onInputValueChange={onInputValueChange}
      inputError={inputError}
    />
  );
};
